<template>
  <div class="columns is-desktop">
    <div v-if="trackedStatuses && trackedStatuses.length > 0" class="column is-7-desktop">
      <div class="ui-bar-element-container is-flex box is-shadowless has-background-white-ter">
        <ui-bar-element
          v-for="(status, index) in trackedStatuses"
          :key="index"
          type="label-item"
          :text="status.badge.label"
          :count="status.count"
          :color="status.badge.color"
          :icon="status.badge"
          :hide-when-zero="false"
        />
      </div>
    </div>

    <div v-if="otherStatuses && otherStatuses.length > 0" class="column is-5-desktop">
      <div class="ui-bar-element-container is-flex box is-shadowless has-background-white-ter">
        <ui-bar-element
          v-for="(status, index) in otherStatuses"
          :key="index"
          type="label-item"
          :text="status.badge.label"
          :count="status.count"
          :color="status.badge.color"
          :icon="status.badge"
          :hide-when-zero="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UiBarElement from '@/components/ui/bar-element'
import IndicatorHelper from '@/helpers/indicator-helper'

export default {
  components: {
    UiBarElement
  },
  props: {
    data: Object
  },
  computed: {
    trackedStatuses() {
      if (this.allCountEqualZero) return []

      return IndicatorHelper.getGroupedStatusBadgesProgress({
        inProgressCount: this.data.inProgressCount,
        todoCount: this.data.todoCount
      })
    },

    otherStatuses() {
      if (this.allCountEqualZero) return []

      return IndicatorHelper.getGroupedStatusBadgesProgress({
        lateCount: this.data.lateCount,
        documentsTodoCount: this.data.documentsTodoCount
      })
    },

    allCountEqualZero() {
      if (!this.data) return true

      return (
        this.data.inProgressCount === 0 &&
        this.data.lateCount === 0 &&
        this.data.todoCount === 0 &&
        this.data.documentsTodoCount === 0
      )
    }
  }
}
</script>

<style lang="scss">
  .ui-bar-element-container {
    & {
      flex-wrap: wrap;
      height: 100%;
      column-gap: $space-16px;
      row-gap: $space-16px;
    }
  }
</style>
